import { Room } from 'src/app/shared/models/room.model';

export const isRoomsWithDifferentCurrencies = (rooms: Room[]): boolean => {
  if (!rooms || rooms.length === 0) {
    return false;
  }

  const roomsWithCurrency = rooms.filter(
    room => !!room?.price?.currency?.currencyCode
  );

  if (roomsWithCurrency.length < 2) {
    return false;
  }

  const currency = roomsWithCurrency[0].price.currency.currencyCode;
  return roomsWithCurrency
    .slice(1)
    .some(room => room.price.currency.currencyCode !== currency);
};

export const hasRibbon = (room: Room): boolean => room.isPrestige || room.isBestValue || room.isHighDemand;

// Centre is returned in search results but can't be booked until its opening date.
export const isOpeningSoon = (room: Room): boolean =>
  !!room?.dateOpened && new Date(room.dateOpened).getTime() > Date.now();

export const getRibbonTitle = (room: Room): null | string => {
  if (!hasRibbon(room)) {
    return null;
  }

  return room.isHighDemand ?
    'highDemandMarkLabel' :
    (room.isPrestige ? 'prestigeMarkLabel' : (room.isBestValue ? 'bestValueMarkLabel' : ''));
};

export const cloudinaryTextConfig = {
  position: {
    top: 'north',
    bottom: 'south'
  },
  font: {
    family: { helvetica: 'helvetica' },
    size: { small: '20' }
  },
  align: {
    l: 'left',
    c: 'center',
    r: 'right'
  },
  background: {
    black: 'black',
    opacity: '78'
  },
  color: {
    white: 'white',
  },
  layer: {
    width: '454',
    height: '25'
  }
}

export const getImageUrlWithText = (originalUrl: string, contentBlock: string): string => {
  const cloudinaryImgTransformParams = '/f_auto,w_454,h_340,c_scale/';
  const fallBackImgParams = '/image/upload/';
  const cloudinaryTextOverlay = `${cloudinaryImgTransformParams}l_text:${cloudinaryTextConfig.font.family.helvetica}_${cloudinaryTextConfig.font.size.small}_alignmentvalue_${cloudinaryTextConfig.align.l}:%20${contentBlock},g_${cloudinaryTextConfig.position.top},w_${cloudinaryTextConfig.layer.width},h_${cloudinaryTextConfig.layer.height},c_fit,y_0,b_${cloudinaryTextConfig.background.black},co_${cloudinaryTextConfig.color.white},o_${cloudinaryTextConfig.background.opacity}/`;
  const fallBackResultParams = `${fallBackImgParams}${cloudinaryTextOverlay}`;
  return originalUrl.indexOf(cloudinaryImgTransformParams) > 0 ? `${originalUrl.replace(cloudinaryImgTransformParams, cloudinaryTextOverlay)}` : `${originalUrl.replace(fallBackImgParams, fallBackResultParams)}`;
}
